/**
 * Entra ID (public SPA registration) — single source for the React app.
 * Same values live in API appsettings AzureAd:* for JWT validation.
 * Not secrets; do not duplicate across env.* files.
 */
export const AZURE_CLIENT_ID = 'a3c0e762-cca9-4ad7-9241-da6299baa336';
export const AZURE_TENANT_ID = '55f0c016-aadc-430f-a7a3-df9b001c0cdb';
export const AZURE_API_SCOPE = `api://${AZURE_CLIENT_ID}/access_as_user`;

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read', 'User.ReadBasic.All', AZURE_API_SCOPE],
};

export const apiRequest = {
  scopes: [AZURE_API_SCOPE],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export const armRequest = {
  scopes: ['https://management.azure.com/user_impersonation'],
};

// IMPORTANT: These delegated permissions must be added to the app registration
// in Entra ID and granted admin consent:
//   - SecurityEvents.Read.All
//   - Organization.Read.All
export const graphSecurityRequest = {
  scopes: ['SecurityEvents.Read.All', 'Organization.Read.All'],
};
